import { render, staticRenderFns } from "./addStory.vue?vue&type=template&id=123d85eb&scoped=true&"
import script from "./addStory.vue?vue&type=script&lang=js&"
export * from "./addStory.vue?vue&type=script&lang=js&"
import style0 from "./addStory.vue?vue&type=style&index=0&id=123d85eb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d85eb",
  null
  
)

export default component.exports